import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const ChevronDown = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 12 7">
    <path
      d="M1 1.49998L6 5.49998L11 1.49998"
      strokeLinecap="round"
      strokeWidth={2}
      fill="transparent"
    />
  </SvgIcon>
);
